import { useDocumentScrollThrottled } from '@hooks/layout/useDocumentEventThrottled';
import { useCallback, useRef } from 'react';

type ScrollDirection = 'up' | 'down' | 'neutral';

export const useScrollDirectionChange = (
  onScrollDirectionChange: ({
    direction,
  }: {
    direction: ScrollDirection;
  }) => void,
) => {
  const previousScrollPosition = useRef(0);
  const previousScrollDirection = useRef<ScrollDirection>('neutral');

  const offsetThresholdInPixel = 50;

  const handleScroll = useCallback(() => {
    const scrollTop = Math.max(
      document.documentElement.scrollTop || document.body.scrollTop,
      0,
    );

    const scrollOffset = scrollTop - previousScrollPosition.current;

    const direction: ScrollDirection = (() => {
      if (scrollOffset > offsetThresholdInPixel) {
        return 'down';
      }

      if (scrollOffset < -offsetThresholdInPixel) {
        return 'up';
      }

      return 'neutral';
    })();

    previousScrollPosition.current = scrollTop;

    if (
      previousScrollDirection.current !== direction &&
      direction !== 'neutral'
    ) {
      previousScrollDirection.current = direction;
      onScrollDirectionChange({ direction });
    }
  }, [onScrollDirectionChange]);

  return useDocumentScrollThrottled(handleScroll);
};
